<template>
  <div class="content  cf-wrap">
    <fundraise-menu>
      <template slot="title">
        <div>Custom Fields</div>
        <p>Create custom questions and fields that you can add to donation checkouts</p>
      </template>
    </fundraise-menu>

    <div class="settings-body">
      <div class="settings-body-inner">

        <div class="row">
          <div class="col-md-6">
            <div class="s-block shadow-md">
              <div class="s-block-header">Custom Fields</div>
              <div class="s-block-body sbd-fundraise">

                <table v-if="!loading && customFields.length" class="table">
                  <tr>
                    <th>Name</th>
                    <th >Type</th>
                    <th>Description</th>
                    <th>Actions</th>
                  </tr>
                  <tr v-for="field in customFields"
                      :key="field.id"
                  >
                    <td>{{field.properties.name}}
                      <span v-if="field.archived"
                            class="guest-pill guest-pill-archived">Archived</span>
                    </td>
                    <td>{{field.properties.type}}</td>
                    <td>{{field.properties.description}}</td>
                    <td class="actions-icons">
                      <div class="dropdown payouts-report-dropdown">
                    <span class="dropbtn dropbtn-only-one"
                          :data-dropdown="`.select-dr${field.id}`"></span>
                        <div :class="`dropdown-content dropdown-right select-dr${field.id}`">
                          <a @click.prevent="editCustomField(field)" href="#">
                            <font-awesome-icon :icon="['fa', 'edit']"/>
                            Edit
                          </a>

                          <a v-if="!field.archived" href="#"
                             @click.prevent="archiveCustomField(field)">
                            <font-awesome-icon :icon="['fa', 'archive']"/>
                            Archive
                          </a>

                          <a v-else href="#" @click.prevent="unarchiveCustomField(field)">
                            <font-awesome-icon :icon="['fa', 'trash-restore']"/>
                            Unarchive
                          </a>

                          <a href="#" @click.prevent="promptDeleteCustomField(field)">
                            <font-awesome-icon :icon="['fa', 'trash-alt']"/>
                            Delete
                          </a>

                        </div>
                      </div>


                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="btn-wrap">
                      <div class="btn-wrap">
                        <a class="btn btn-sm"
                           @click.prevent="createCustomField"
                           href="#"
                           style="margin-left: 0; padding: 11px 12px;">+ Add Custom Field</a></div>
                    </td>
                    <td></td>

                  </tr>
                </table>

                <div v-else-if="!loading" class="empty-placeholder">
                  <img :src="require('../../assets/paceholders/8.svg')" alt="No results">
                  <h3>No Custom Fields Yet</h3>
                  <div class="btn-wrap mt-4">
                    <a class="btn btn-sm"
                       @click.prevent="createCustomField"
                       href="#"
                       style="margin-left: 0; padding: 11px 12px;">+ Add Custom Field</a></div>
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="s-block shadow-md">
              <div class="s-block-header">Standard Fields</div>
              <div class="s-block-body sbd-fundraise">
                <table class="table">
                  <tr>
                    <th>Name</th>
                    <th >Type</th>
                  </tr>

                  <tr>
                    <td>First Name</td>
                    <td>text</td>
                  </tr>
                  <tr>
                    <td>Last Name</td>
                    <td>text</td>
                  </tr>
                  <tr>
                    <td>Email Address</td>
                    <td>text</td>
                  </tr>
                  <tr>
                    <td>Phone Number</td>
                    <td>text</td>
                  </tr>
                  <tr>
                    <td>Date of Birth</td>
                    <td>date</td>
                  </tr>
                  <tr>
                    <td>Gender</td>
                    <td>text</td>
                  </tr>
                  <tr>
                    <td>Employer</td>
                    <td>text</td>
                  </tr>
                  <tr>
                    <td>Position</td>
                    <td>text</td>
                  </tr>
                  <tr>
                    <td>Street Address</td>
                    <td>text</td>
                  </tr>
                  <tr>
                    <td>Street Address 2</td>
                    <td>text</td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td>text</td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>text</td>
                  </tr>
                  <tr>
                    <td>Zip Code</td>
                    <td>text</td>
                  </tr>
                </table>
              </div>

            </div>
          </div>
        </div>

      </div>

    </div>

    <v-dialog/>

    <v-modal :width="600"
             :height="'70%'"
             name="add-cf">
      <div v-if="editor.active" class="cf-modal-wrap">
        <div class="modal-header">
          <a @click="!editor.disabled && cancelEdit()"
             style="float: right"
             href="#"
             aria-label="Close"
          >
            <font-awesome-icon :icon="['fas', 'times']"/>
          </a>
          <div v-if="editor.isCreatingNewCustomField"
               class="modal-title h5">New Custom Field
          </div>
          <div v-else class="modal-title h5">Edit Custom Field</div>

          <div v-for="(error, index) in editor.errors" class="toast toast-error my-1"
               :key="index"
          >{{error}}
          </div>
        </div>
        <div class="modal-body" style="min-height: 240px">
          <form>
            <div :disabled="editor.disabled">
              <div class="form-item">

                <multiselect :options="['text', 'select', 'radio', 'checkbox', 'date']"
                             placeholder="Select a type"
                             :class="'multiselect-icons'"
                             v-model="editor.customField.properties.type"
                             :close-on-select="true"
                             :show-labels="false"
                             :searchable="false"
                             :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="props">
                    <span style="text-transform: capitalize;">{{ props.option }}</span>
                  </template>
                  <template slot="option" slot-scope="props"><span
                     style="text-transform: capitalize;">{{props.option}}</span></template>
                </multiselect>

              </div>

              <form-input-text
                 v-model="editor.customField.properties.name"
                 :label="'Name'"
              ></form-input-text>

              <form-input-text
                 v-model="editor.customField.properties.description"
                 :label="'Description'"
              ></form-input-text>

              <form-input-text
                 v-if="false"
                 v-model="editor.customField.properties.tooltip"
                 :label="'Tooltip'"
              ></form-input-text>

              <form-input-text
                 v-if="false"
                 v-model="editor.customField.properties.icon"
                 :label="'Icon'"
              ></form-input-text>

              <!-- Input options for TEXT fields -->

              <div v-if="editor.customField.properties.type === 'text'">
                <div class="form-item">
                  <label class="form-label">Max Length</label>
                  <input
                     type="number"
                     v-model.number="editor.customField.properties.max_length"
                     class="form-control"
                     min="1"
                     max="1000"
                  />
                </div>

                <form-input-text
                   v-model="editor.customField.properties.placeholder"
                   :label="'Placeholder'"
                ></form-input-text>

                <div class="form-item">
                  <label class="form-label">Options</label>
                  <div class="form-group">
                    <el-switch v-model="editor.customField.properties.multiline"
                               active-text="Multiline"
                    ></el-switch>
                  </div>
                </div>
              </div>

              <!-- Input options for SELECT fields -->

              <div v-if="editor.customField.properties.type === 'select'">
                <label class="form-label">Select Options</label>
                <div
                   v-for="(option, index) in editor.customField.properties.options"
                   :key="index"
                   class="bg-gray m-2 p-2"
                >
                  <form-input-text
                     v-model="option.name"
                     :label="'Name'"
                  ></form-input-text>

                  <form-input-text
                     v-model.number="option.value"
                     :label="'Value'"
                     :disabled="true"
                  ></form-input-text>

                  <div class="form-group">
                    <div class="mb-3">
                      <el-switch v-model="option.disabled"
                                 active-text="Disabled"
                      ></el-switch>
                    </div>

                    <form-input-radio-boolean
                       v-model="option.value"
                       :checked="option.selected"
                       :label="'Selected'"
                       :name="'selected'"
                       :id="'select-' + option.value"
                       @input="updateSelectedOptions"
                    ></form-input-radio-boolean>

                    <button
                       style="float: right"
                       class="float-right"
                       @click.prevent="editor.customField.properties.options.splice(index, 1)"
                    >
                      <font-awesome-icon :icon="['fas', 'trash-alt']"/>
                    </button>
                  </div>
                </div>

                <div class="btn-wrap">
                  <button
                     @click.prevent="addNewSelectOption"
                     class="btn btn-sm">
                    Add Option
                  </button>
                </div>
              </div>

              <!-- Input options for RADIO fields -->

              <div v-if="editor.customField.properties.type === 'radio'">
                <label class="form-label">Radio Options</label>
                <div
                   v-for="(option, index) in editor.customField.properties.options"
                   :key="index"
                   class="bg-gray m-2 p-2"
                >
                  <form-input-text
                     v-model="option.name"
                     :label="'Name'"
                  ></form-input-text>

                  <form-input-text
                     v-model.number="option.value"
                     :label="'Value'"
                     :disabled="true"
                  ></form-input-text>

                  <div class="form-group">
                    <form-input-radio-boolean
                       v-model="option.value"
                       :checked="option.selected"
                       :label="'Selected'"
                       :name="'selected'"
                       :id="'radio-' + option.value"
                       @input="updateSelectedOptions"
                    ></form-input-radio-boolean>

                    <button
                       style="float: right"
                       @click.prevent="editor.customField.properties.options.splice(index, 1)"
                    >
                      <font-awesome-icon :icon="['fas', 'trash-alt']"/>
                    </button>
                  </div>
                </div>

                <div class="btn-wrap">
                  <button
                     @click.prevent="addNewSelectOption"
                     class="btn btn-sm">
                    Add Option
                  </button>
                </div>
              </div>

              <!-- Input options for CHECKBOX fields -->

              <div v-if="editor.customField.properties.type === 'checkbox'">
                <div class="form-group">
                  <label class="form-label">Options</label><br>

                  <el-switch v-model="editor.customField.properties.selected"
                             active-text="Checked"
                  ></el-switch>

                </div>
              </div>

              <!-- Input options for DATE fields -->

              <div v-if="editor.customField.properties.type === 'date'">
                <div class="form-group">
                  <label class="form-label">Date Precision</label>
                  <select class="form-control"
                          v-model="editor.customField.properties.precision">
                    <option disabled="disabled">Select a date precision</option>
                    <option value="y-m-d">Year, Month, and Day</option>
                    <option value="y-m">Year and Month</option>
                    <option value="y">Year</option>
                    <option value="m">Month</option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="text-right btn-wrap" :disabled="editor.disabled">
            <a href="#" class="btn btn-sm btn-cancel" @click.prevent="cancelEdit">Cancel</a>
            <a href="#" class="btn btn-sm" @click.prevent="save">Save</a>
          </div>
        </div>
      </div>

    </v-modal>


  </div>
</template>

<script>
  import FundraiseMenu from './menu.vue';
  import {customFields} from '@/utils/api';
  import FormInputText from './Controls/FormInputText';
  import FormInputRadioBoolean from './Controls/FormInputRadioBoolean';
  import FormInputFileUpload from './Controls/FormInputFileUpload';
  import Multiselect from 'vue-multiselect';
  import Switches from 'vue-switches';
  import {mapState} from "vuex";

  export default {
    name: 'ImpactAmounts',

    metaInfo: {
      title: 'Fundraise - Custom Fields',
    },
    components: {
      FundraiseMenu,
      FormInputText,
      FormInputRadioBoolean,
      FormInputFileUpload,
      Multiselect,
      Switches,
    },
    mounted() {
      this.updateFields();
    },
    methods: {
      createCustomField() {

        this.editor.active = true;
        this.editor.disabled = false;
        this.editor.isCreatingNewCustomField = true;
        this.editor.customField = this.getCustomFieldTemplate();
        this.editor.customFieldBeforeEdits = this.getCustomFieldTemplate();
        this.editor.errors = [];

        this.$modal.show('add-cf');
      },
      editCustomField(customField) {
        this.editor.active = true;
        this.editor.disabled = false;
        this.editor.isCreatingNewCustomField = false;
        this.editor.customField = customField;
        this.editor.errors = [];

        // Perform a deep copy of the customField to save.
        this.editor.customFieldBeforeEdits = JSON.parse(JSON.stringify(customField));

        this.$modal.show('add-cf');
      },
      save() {
        this.editor.errors = [];

        if (this.editor.isCreatingNewCustomField) {
          this.saveNew();
        } else {
          this.saveEdit();
        }
      },
      saveNew() {
        let customField = this.editor.customField;
        customFields.create(this.editor.customField.properties, this.activeCharityId)
          .then(() => {
            this.updateFields();
            this.$message(`Custom filed "${customField.properties.name}" created`);
            this.closeEditor();
          }).catch(err => {
          if (err.errors) {
            this.editor.errors = Array.isArray(err.errors) ? err.errors : [err.errors];
          } else {
            alert(err);
          }
        });
      },
      saveEdit() {
        let customField = this.editor.customField;
        customFields.update(
          customField.id,
          JSON.stringify(customField.properties),
          this.activeCharityId
        ).then(() => {
          this.updateFields();
          this.$message(`Custom filed "${customField.properties.name}" updated`);
          this.closeEditor();
        }).catch(err => {
          if (err.errors) {
            this.editor.errors = Array.isArray(err.errors) ? err.errors : [err.errors];
          } else {
            alert(err);
          }
        });
      },
      cancelEdit() {
        // Copy the old properties back, discarding any edits.
        Object.assign(this.editor.customField, this.editor.customFieldBeforeEdits);

        this.closeEditor();
      },
      /**
       * Close and reset the editor back to default state.
       */
      closeEditor() {
        this.editor.active = false;
        this.editor.disabled = false;
        this.editor.customField = null;
        this.editor.customFieldBeforeEdits = null;
        this.editor.newFunctionality = '';
        this.editor.activePage = 'details';
        this.$modal.hide('add-cf');
      },

      getCustomFieldTemplate() {
        return {
          'id': null,
          'properties': {
            'type': null,
            'name': null,
            'description': null,
            'tooltip': null,
            'icon': null,
          },
          'created_at': null,
          'updated_at': null,
        };
      },

      /**
       * Add a new Option for `Select` and `Radio` custom fields.
       */
      addNewSelectOption() {
        if (!this.editor.customField.properties.options) {
          this.$set(this.editor.customField.properties, 'options', []);
        }

        // Find the max current `value`, then add 1.
        let value = Number(this.editor.customField.properties.options.reduce((max, opt) => {
          if (opt.value > max) return opt.value;
          return max;
        }, 0)) + 1;

        this.editor.customField.properties.options.push({
          name: '',
          value: value,
          disabled: false,
          selected: false,
        });
      },

      /**
       * Called when the `selected` radio input is changed for a Select field's option.
       * This is the easiest way to make sure each `selected` property is updated
       * for all of the options, since there's no easy way to know when a radio is deselected.
       */
      updateSelectedOptions(value) {
        this.editor.customField.properties.options.forEach((opt) => {
          opt.selected = opt.value == value;
        });
      },

      archiveCustomField(field) {
        customFields.archive(field.id, this.activeCharityId).then(() => {
          this.$message(`Custom filed "${field.properties.name}" archived`);
          field.archived = true;
        }).catch(err => alert(err));
      },

      unarchiveCustomField(field) {
        customFields.unarchive(field.id, this.activeCharityId).then(() => {
          this.$message(`Custom filed "${field.properties.name}" unarchived`);
          field.archived = false
        }).catch(err => alert(err));
      },

      promptDeleteCustomField(customField) {

        this.$modal.show('dialog', {
          title: 'Confirm',
          'class': 'modal-delete',
          text: `Are you sure you want to delete the Custom Field, "${customField.properties.name}"?`,
          buttons: [
            {
              title: 'No, cancel',
              default: true,
              handler: () => {
                this.$modal.hide('dialog');
              }
            },
            {
              title: 'Yes, delete it',
              class: 'btn btn-sm btn-delete',
              handler: () => {
                customFields.delete(customField.id, this.activeCharityId).then(() => {
                  this.$message(`Custom filed "${customField.properties.name}" deleted`);
                  this.$modal.hide('dialog');
                  this.updateFields();
                }).catch(err => alert(err));
              },
            },
          ],
        });
      },

      updateFields() {
        customFields.getAll(this.activeCharityId).then(cf => {
          this.loading = false;
          this.customFields = cf;
        });
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
      }),
    },
    watch: {
      'activeCharityId'() {
        this.updateFields();
      },
    },
    data() {
      return {
        loading: true,
        customFields: [],
        editor: {
          active: false,
          disabled: false,
          isCreatingNewCustomField: false,
          customField: null,
          customFieldBeforeEdits: null,
          errors: [],
        },
        // deleteCustomField: null,
        charityData: null,
      };
    },
  };
</script>

